<script>
import { sendFandomAnalyticsEvent }  from "src/modules/fandom_analytics_module.js";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";

export default {
  mixins: [fandomBasicMixin],
  methods: {
    formSubmitDone (data) {
      if (data.success) {
        sendFandomAnalyticsEvent("Simple Form", "Submit", `content_${this.contentName}_interaction_${this.content.interaction.id}`);
      }
    },
    getContentStyle () {
      var styleObject = {};
      if (Fandom.exists(this.content.background_color)) {
        styleObject["background-color"] = this.content.background_color;
      }
      if (Fandom.exists(this.content.background_image)) {
        styleObject["background-image"] = this.getContentResponsiveImageURL("background_image");
      }
      if (Fandom.exists(this.content.text_color)) {
        styleObject["color"] = this.content.text_color;
      }
      return styleObject;
    }
  }
};
</script>

<template>
  <div :id="content.name" v-easyadmin="easyadminId" class="bg-cover-center" :style="getContentStyle()" simple-form-component>
    <div class="container">
      <!-- margin management -->
      <div class="row justify-content-center align-items-center py-5">
        <div class="col-sm-12 col-md-8 col-sm-6 pt-md-4">

          <component v-if="content.title" :class="content.title_class || 'h1'" :is="content.title_tag || 'h2'">{{content.title}}</component>
          <component v-if="content.description" :class="content.description_class" :is="content.description_tag || 'p'" v-html="content.description"></component>

          <generic-form :content="content" :opt-container-content="containerContent" @done="formSubmitDone"></generic-form>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[simple-form-component] {
  [generic-form-component] {
    form > button {
      display: block;
      margin-left: auto !important;
      margin-right: auto !important;
      margin-top: 3rem;
    }

    input.form-check-input {
      margin-top: 8px !important;
    }

    .text-muted {
      display: none;
    }
  }
}
</style>
